const firebaseConfig = {
  apiKey: 'AIzaSyCEgCeqFxz847o14mksWjJub4_Bne-dpsY',
  authDomain: 'congress-feedback-platform.firebaseapp.com',
  projectId: 'congress-feedback-platform',
  databaseId: 'daiichi-sankyo-wclc-2026',
  databaseURL: 'https://daiichi-sankyo-wclc-2026.europe-west1.firebasedatabase.app/',
  storageBucket: 'congress-feedback-platform.firebasestorage.app',
  messagingSenderId: '59906633527',
  appId: '1:59906633527:web:1929b0e780fcbf3d78b4b2',
  measurementId: 'G-3FQWVBK1KW'
};

export default firebaseConfig;
